import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme, { headerColor }) => ({
  noteCard: {
    width: "100%",
    height: "350px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 500px)": {
      height: "100%",
    },
  },
  header: {
    display: "flex",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    backgroundColor: headerColor || "#F2F4F7",
  },
  body: {
    height: "300px",
    overflow: "auto",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #ccc",
    padding: "20px",
    gap: "1rem",
  },
  deleteModal: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    padding: "10px 0 0 0",
  },
  btnsFlex: {
    display: "flex",
    gap: "0.5rem",
    width: "100%",
  },
  modalBtns: {
    width: "100%",
  },
  deleteModalIcon: {
    width: "50px",
  },
}));

export default useStyles;
